import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 THE 100+ TACTICAL REPORT AI PROMPTS™',
  ideal: 'Patrol Officers, Detectives, and Supervisors who want to protect their career and reclaim their time.',
  was: '$164',
  now: '19',
  features: ['Full 6-Volume Tactical System', '100+ Ready-to-use Attorney-Vetted Prompts', 'Instant compatibility with all major AI models', '4 Free Tactical Bonuses included', '7-Day Risk-Free Guarantee', '♾️ Lifetime Access & Free Updates'],
  cta: 'Get the 100+ Tactical Report AI Prompts™ now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Mobile & MDT'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-120" data-mp="3canypub5biyd">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-121" data-mp="4t5k78y411wg">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-122" data-mp="9rz1lcgipd1w">
          <p className="font-display text-xl font-black text-plum" data-id="element-123" data-mp="9qe2ran677y8">🔥 Limited Offer — Ending Soon!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-124" data-mp="3d8z3twnqmthq">
            ⚠️ After this, the price returns to $38. This rate will not come back.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-125" data-mp="3i8k01zbiwnqr">
            🎟️ Only 12 spots left at this price!
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.5)]" data-id="element-126" data-mp="3rzya3113p5y5">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-127" data-mp="3164tiyc6jn3y">
            <h3 className="font-display text-base font-black text-white" data-id="element-128" data-mp="2w8mgowv1knqo">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-129" data-mp="28j1w69j8pifa">
            <span className="font-semibold text-plum/80" data-id="element-130" data-mp="28jtrrkcu7g5k">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-131" data-mp="23la3hdartsa1">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-132" data-mp="2iggdebczmb8n">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-133" data-mp="2dgu061x5suzu">
              <span className="relative inline-block font-display leading-none" data-id="element-134" data-mp="2djg5duwkuyew">
                <span className="absolute right-full top-1/2 mr-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-135" data-mp="3ttil0gx3zqgo">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-136" data-mp="59gqsd2ys3s1">
                  {plan.now}
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-137" data-mp="3rg59jldagy3p">
              · One-time payment · Lifetime Access ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-138" data-mp="j1n4lsin9yob">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-139" data-mp="nzg8gewh6glf">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-140" data-mp="a7s1sr4zwkbu" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-141" data-mp="11zr3zv8qcjcx">
            <CTAButton size="md" data-id="element-142" data-mp="11y69u6qbv2fl">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-143" data-mp="16qpkovxmrjgp">
            Save $145 (88% Off)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-144" data-mp="3f8jto6qvg934">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="35aduvy0d3j2h">
                <Icon className="h-4 w-4 text-grape" data-id="element-146" data-mp="3189211hqmqgw" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-147" data-mp="1s453ijx0cu9">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-148" data-mp="3o86xez72pqzc" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-149" data-mp="3o63zzu3lcvkl">
            <span className="font-display font-bold text-plum" data-id="element-150" data-mp="3k5tu0hfsu55q">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel that this system doesn't save you at least 1 hour of
            paperwork per day, just ask for a refund. We will return 100% of your money, no questions
            asked. SIGMA SMART™ is committed to your career protection.
          </p>
        </div>
      </div>
    </section>;
}